import { Component } from '@angular/core';

@Component({
  selector: 'app-help-form',
  templateUrl: './help-form.component.html',
  styleUrls: ['./help-form.component.scss']
})
export class HelpFormComponent {
  isLoading = true

  onLoad() {

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }
}
